<template>
  <section>
    <!-- ROUTER HEADER SHOULD GO HERE -->
    <div class="page-banner">
      <div class="container-fluid border-bottom">
        <div class="row align-items-center">
          <div class="col-md-7 p-4 pt-5">
            <h1>
              <img
                src="@/assets/img/_title/08-JS-make-your-resume-and-cover-letter-shine.svg"
                class="img-fluid"
                alt="Make your resume and cover letter shine"
                srcset=""
              >
            </h1>
          </div>
          <div class="col-md-5 p-5">
          </div>
        </div>
      </div>
    </div>

    <!-- ROUTER CONTENT GOES HERE -->
    <!-- TEXT CONTENT -->
    <content-block class="bg-light-grey">
      <div class="row">
        <div class="col-md bg-img bg-img--job-search-08">
          <!-- <img
            src="assets/img/_content/template-placeholder-01.jpg"
            alt=""
            class="img-fluid content-block__img"
          > -->
        </div>
        <div class="col-md-7 px-4">
          <p>To learn more about how you can design a resume and cover letter that really grab employers’ attention, check out the webinar, <a href="https://www.wevideo.com/view/1665096589" target="_blank">How to create effective resumes and cover letters</a> by the Career Services team at Centennial.</p>
          <p>You can also use your myCentennial credentials to sign into the <a href="https://hire.centennialcollege.ca/home.htm" target="_blank">HireCentennial</a> resource portal, which offers…</p>
          <div class="carousel carousel--green">
            <hooper
              ref="carousel_01"
              class="mb-4"
            >
              <slide>
                <div class="slide">
                  <li>Daily drop-ins and appointments to support you at any stage of your job search and career planning, including resume and cover letter review, a LinkedIn profile review, job search planning, interview preparation and practice and more</li>
                </div>
              </slide>

              <slide>
                <div class="slide">
                  <li>Downloadable tip sheets, resume and cover letter templates and samples for different programs of study</li>
                </div>
              </slide>

              <slide>
                <div class="slide">
                  <li>Access to job postings and exclusive online tools to help with career planning, interview practice and networking</li>
                </div>
              </slide>

              <hooper-navigation slot="hooper-addons">
                <img
                  slot="hooper-prev"
                  src="@/assets/img/_ui/svg/carousel-back--green.svg"
                  alt="previous"
                  srcset=""
                >
                <img
                  slot="hooper-next"
                  src="@/assets/img/_ui/svg/carousel-next--green.svg"
                  alt="next"
                  srcset=""
                >
              </hooper-navigation>

              <hooper-pagination slot="hooper-addons"></hooper-pagination>
            </hooper>
          </div>
          <div class="learn-more learn-more--green">
            <p><strong>Learn more</strong>
              <ul>
                <li><a
                  :href="`${publicPath}docs/Tip sheets and other materials/5- Resume Verbs - skills and actions.pdf`"
                  target="_blank"
                >Resume verbs: Skills and actions tip sheet</a></li>
                <li>Centennial College <a href="https://hire.centennialcollege.ca/home.htm" target="_blank">Career Services</a></li>
              </ul></p>
          </div>
        </div>
      </div>
    </content-block>
  </section>
</template>

<script>
import ContentBlock from '@/components/ContentBlock.vue'
// import Accordion from '@/components/Accordion.vue'
// import SidebarMenu from '../components/SidebarMenu.vue'
import {
  Hooper,
  Slide,
  Navigation as HooperNavigation,
  Pagination as HooperPagination
} from 'hooper'
import 'hooper/dist/hooper.css'

export default {
  name: '01',
  components: {
    ContentBlock,
    // SidebarMenu,
    // Accordion,
    Hooper,
    Slide,
    HooperNavigation,
    HooperPagination
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },

  mounted () {
  }
}
</script>

<style>
</style>
